import { AudienceStatus } from 'app/audiences/types'

import { StatusType } from 'components'

export const translateStatus = (status: AudienceStatus): StatusType => {
  switch (status) {
    case 'archieved':
    case 'paused':
      return 'inactive'
    case 'preparation':
      return 'draft'
    default:
      return 'active'
  }
}
